export default __webpack_public_path__ + "57ef6b3db9d976572de53c09c50e44cf.png";